import request from '~/request/index.js'


/**
  *新增职位
  *POST /api/v1/business/position
  *接口ID：208402958
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-208402958
  */
export const addPositionGroupApi = (data) => request.post(`/api/v1/business/position`, data)

/**
 * 修改职位
  *PUT /api/v1/business/position
  *接口ID：208402959
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-208402959
 */
export const editPositionGroupApi = (data) => request.put(`/api/v1/business/position`, data)

/**
 * 查询职位列表
  *GET /api/v1/business/position/list
  *接口ID：208402956
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-208402956
 */
export const getPositionGroupListApi = (name,withProfile=null) => {
      const params = {
        name:name,   
      };     
      if(withProfile != null){
          params.withProfile = withProfile
      } 
  return request.get('/api/v1/business/position/list', {params})
}

/**
查询系统职位列表
  GET /system/position/list
  接口ID：214855433
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-214855433
 */
export const getSystemPositionListApi = (name) => request.get(`/system/position/list${name ? `?name=${name}` : ''}`)

/**
 * 删除职位
  *DELETE /api/v1/business/position/{ids}
  *接口ID：208402960
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-208402960
 */
export const delPositionGroupApi = (ids) => request.delete(`/api/v1/business/position/${ids}`)

/**
 * 新增职位画像
  *POST /api/v1/business/position-profile
  *接口ID：208403031
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-208403031
 */
export const addPositionProfileApi = (data) => request.post(`/api/v1/business/position-profile`,data)

/**
 * 修改职位画像
  *PUT /api/v1/business/position-profile
  *接口ID：208403032
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-208403032
 */
export const editPositionProfileApi = (data) => request.put(`/api/v1/business/position-profile`,data)

/**
 * 查询职位画像列表
  *GET /api/v1/business/position-profile/list
  *接口ID：208403029
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-208403029
 */
export const getPositionProfileListApi = (positionId,positionIdIsNull,pageSize = 100,pageNum = 1) => request.get('/api/v1/business/position-profile/list', {
    params: {
        isAsc: 'desc',
        orderByColumn: 'createTime',
        pageSize,
        pageNum,
        ...(positionId && { positionId }),
        ...(positionIdIsNull && { positionIdIsNull }),
    }
})

/**
 * 查询职位画像列表-systeam
  *GET /api/v1/business/position-profile/list
  *接口ID：208403029
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-208403029
 */
  export const getNewSystemPositionProfileListApi = (positionId) => request.get(`/system/position-profile/list?isAsc=desc&orderByColumn=createTime${positionId ? `&positionId=${positionId}` : ''}`)

/**
 * 查询系统职位画像列表-公共
  GET /system/position-profile/list
  接口ID：215112320
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-215112320
 */
export const getSystemPositionProfileListApi = (positionId) => request.get(`/system/position-profile/list?positionId=${positionId}`)


/**
 * 删除职位画像
  DELETE /api/v1/business/position-profile/{ids}
  接口ID：208403033
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-208403033
 */
export const delPositionProfileApi = (ids) => request.delete(`/api/v1/business/position-profile/${ids}`)

/**
 * 获取职位画像详细信息
  *GET /api/v1/business/position-profile/{id}
  *接口ID：208403030
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-208403030
 */
export const getPositionProfileMainApi = (id) => request.get(`/api/v1/business/position-profile/${id}`)
export const getSystemPositionProfileMainApi = (id) => request.get(`/system/position-profile/${id}`)

/**
 * 查询画像能力列表
  *GET /api/v1/business/profileAbility/list
  *接口ID：208403059
  *接口地址：https://app.apifox.com/link/project/5047271/apis/api-208403059
 */
export const getprofileAbilityApi = (profileId) => request.get(`/api/v1/business/profileAbility/list?profileId=${profileId}`)


/**
 * 新增画像能力
  POST /api/v1/business/profileAbility
  接口ID：208403061
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-208403061
 */
export const addprofileAbilityApi = (data) => request.post(`/api/v1/business/profileAbility`,data)

/**
 * 修改画像能力
  PUT /api/v1/business/profileAbility
  接口ID：208403062
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-208403062
 */
export const editprofileAbilityApi = (data) => request.put(`/api/v1/business/profileAbility`,data)

/**
 * 删除画像能力
  DELETE /api/v1/business/profileAbility/{ids}
  接口ID：208403063
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-208403063
 */
export const delProfileAbilityApi = (ids) => request.delete(`/api/v1/business/profileAbility/${ids}`)

/**
 * 查询系统职位列表-公共
  GET /system/position/list
  接口ID：214855433
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-214855433
 */
export const getSystemPostitionApi = (ids) => request.get(`/system/position/list`)

/**
 * 复制画像.
  POST /api/v1/business/position-profile/{id}/copy
  接口ID：230087651
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-230087651
 */
export const copyPositionProfileApi = (id) => request.post(`/api/v1/business/position-profile/${id}/copy`)

/**
 * 生成jd
  PUT /api/v1/business/position-profile/jd/{profileId}
  接口ID：276636704
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-276636704
 */
export const copyPositionProfileJDApi = (profileId) => request.put(`/api/v1/business/position-profile/jd/${profileId}`)

/**
 * 从公共画像复制
  POST /api/v1/business/position-profile/sys-copy/{sysProfileId}/position/{positionId}
  接口ID：275483899
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-275483899
 */
export const copySysPositionProfileApi = (data) => request.post(`/api/v1/business/position-profile/sys-copy`,data)

/**
 * 获取画像优化详情
  GET /api/v1/business/profile-opt/{id}
  接口ID：303914451
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-303914451
 */
export const getJobProfileOptimizeApi = (id) => request.get(`/api/v1/business/profile-opt/${id}`)

/**
 * 修改画像优化
  PUT /api/v1/business/profile-opt
  接口ID：303957010
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-303957010 
 */
export const updateJobProfileOptimizeApi = (data) => request.put(`/api/v1/business/profile-opt`,data)